<div class="page-not-found text-center">
  <h1>404</h1>
  <h3>Page Not Found</h3>
  <p>The page you’re looking for doesn’t exist or was moved.</p>
  <button routerLink="/" class="btn btn-primary">Go Home</button>
</div>

